import React from "react";

export const CustomButtonClasses = Object.freeze({
  PRIMARY: "btn-primary",
  SECONDARY: "btn-secondary",
  SUCCESS: "btn-success",
  DANGER: "btn-danger",
  WARNING: "btn-warning",
  LIGHT: "btn-light",
  DARK: "btn-dark",
});

export const CustomButtonTypes = Object.freeze({
  BUTTON: "button",
  SUBMIT: "submit",
});

const CustomButton = ({
  type,
  disable = false,
  onClick,
  className,
  children,
  hide = false,
  styles,
}) => {
  if (hide) {
    return null;
  }
  return (
    <button
      className={`btn ${className}`}
      disabled={disable}
      onClick={onClick}
      style={{ ...styles }}
      type={type}
    >
      {children}
    </button>
  );
};

export default CustomButton;
